import { render, staticRenderFns } from "./UiWidgetStats.vue?vue&type=template&id=3477a987"
import script from "./UiWidgetStats.vue?vue&type=script&lang=js"
export * from "./UiWidgetStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports